import component from "./TeamParticipantsReport.js";

export default component;
